import React from 'react'
import { Box, Flex, Stack, Text } from '@chakra-ui/react'
import { IBlogItem } from '@common/interface/blog'
import Link from 'next/link'
import RouterUrl from '@constants/router.constant'
import { useResponsive } from '@common/hooks'
import LinkTextUnderline from '@components/link-text-underline'
import moment from 'moment'
import { BLOG_HEIGHT } from '@constants/blog.constant'
import Image from 'next/image'
import { convertToCloudFrontImage } from '@lib/util/convert-cloudfront-image'

interface BlogCardItemPropsItem {
  item: IBlogItem
}

const BlogCardItem = ({ item }: BlogCardItemPropsItem) => {
  const { lgMax } = useResponsive()
  const { title, mainImage, handle, meta_description, start_date } = item as any

  const link = `${RouterUrl.READ.ROOT}/${handle as string}`

  return (
    <Box bg={'bg'} w={'100%'}>
      <Flex gap={8} flexDirection={lgMax ? 'column' : 'row'}>
        <Flex w={'100%'} flex={1} h={BLOG_HEIGHT} data-aos="fade-right">
          <Link href={link} style={{ width: '100%' }}>
            <Image
              src={mainImage?.url ?? ''}
              alt={title}
              width={565}
              height={350}
              style={{ width: '100%', height: BLOG_HEIGHT, objectFit: 'cover' }}
            />
          </Link>
        </Flex>
        <Flex
          flex={1.5}
          alignItems={'center'}
          h={BLOG_HEIGHT}
          data-aos="fade-left"
        >
          <Stack py={8} w="100%" px={5} gap={3}>
            <Stack>
              <Text
                textStyle={'productItemText'}
                fontWeight="600"
                color={'doveGray'}
                fontSize={'18px'}
              >
                {moment(start_date).format('D MMMM YYYY')}
              </Text>
              <Link href={link}>
                <Text textStyle="blogTitle">{title || ''}</Text>
              </Link>
            </Stack>
            <Text textStyle="topicSmall" w={'95%'}>
              {meta_description || ''}
            </Text>
            <LinkTextUnderline
              text="Read More"
              color="black"
              underlineColor="red"
              href={link}
              textStyle={'blogTitleMedium'}
            />
          </Stack>
        </Flex>
      </Flex>
    </Box>
  )
}

export default BlogCardItem
